const QouteCard = ({ name, title, qoute, avatar, phone, email }) => {

    return (
        <div className="w-full sm:max-w-[400px] max-w-full h-full bg-white border p-6 border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
            <div className="flex gap-4 flex-col items-center h-full">
                <div className="flex flex-row w-full justify-between">
                    <img className="w-24 h-24 rounded-full shadow-lg object-cover" src={avatar} alt={`img_${name}`} />
                    <div className="flex flex-col h-full">
                        <h5 className="mb-1 text-xl font-medium text-gray-900 dark:text-white">{name}</h5>
                        <span className="text-sm text-gray-500 dark:text-gray-400">{title}</span>
                        {phone ? <span className="text-sm text-gray-500 dark:text-gray-400"><a href={`tel:${phone}`}>{phone}</a></span> : null}
                    </div>
                </div>
                <div className="text-center w-full h-full whitespace-pre-line italic flex flex-col space-y-2">
                    <span>{qoute}</span>
                    {email ? <span className="text-sm text-gray-500 dark:text-gray-400"><a href={`mailto:${email}`}>{email}</a></span> : null}
                </div>
            </div>
        </div>

    );
};

export default QouteCard;
